<template>
  <div class="account-cancellation-container">
    <div class="account-cancellation-sub-title">
      {{ $t('account_cancellation_sub_title_1') }}
    </div>
    <div class="account-cancellation-des-list-container">
      <div>{{ $t('account_cancellation_des_1') }}</div>
      <div>{{ $t('account_cancellation_des_2') }}</div>
      <div style="color: red;">{{ $t('account_cancellation_des_4') }}</div>
    </div>
    <div class="account-cancellation-sub-title">
      {{ $t('account_cancellation_sub_title_2') }}
    </div>
    <div class="account-cancellation-des-list-container">
      <div>{{ $t('account_cancellation_des_3') }}</div>
    </div>
    <div class="account-cancellation-btn" @click="deleteAccount">{{ $t('confirm_cancellation') }}</div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "accountCancellation",
  methods: {
    ...mapActions('auth', ['deleteAccount']),
  }
}
</script>

<style lang="less">
.account-cancellation-container {
  padding: 0 16px;
  letter-spacing: 1px;

  .account-cancellation-sub-title {
    color: #7cc26a;
    font-weight: bold;
    font-size: 15px;
    padding: 12px 0;
  }

  .account-cancellation-des-list-container {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 13px;
    font-size: 14px;
    color: rgb(112, 104, 104);
  }

  .account-cancellation-btn {
    width: calc(100% - 32px);
    background-color: #7cc26a;
    color: #FFFFFF;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 2px;
    height: 36px;
    border-radius: 22px;
    position: fixed;
    bottom: 90px;
    left: 16px;
    right: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Profile/accountCancellation.vue